import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const extraDefinitionValuesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getExtraDefinitionValues({entity: 'patients', entity_id: to.params.id as string});
        to.meta.extra_definition_values = res.data.data;
    } catch(error) {
        console.error('EXTRA_DEFINITION_VALUES_RESOLVER_ERROR');
        return { name: 'Patients' };
    }
}